// extracted by mini-css-extract-plugin
export default {"monitorRoutes":"monitorRoutes-nGdk0","tabPanel":"tabPanel-TExtm","tabs":"tabs-xniRV","routeErrorContainer":"routeErrorContainer-Xfiq4"};